export default __webpack_public_path__ + "static/media/whitetail@3x.153a72b5.jpg";